module.exports = __webpack_public_path__ + "media/images/calendar_icon-cda62f2c167c7e1c3fb90f41263e8167.svg";